import { combineReducers } from 'redux';
import payments from './payments';
import stores from './stores';
import users from './users';
import settings from './settings';
import locations from './locations';
import cartLayouts from './cartLayouts';
import zones from './zones';

export default combineReducers({
  payments,
  stores,
  locations,
  cartLayouts,
  zones,
  users,
  settings,
});